export type AttachmentPreviewKind =
  | 'image'
  | 'pdf'
  | 'video'
  | 'audio'
  | 'text'
  | 'unsupported';

export interface PreviewableAttachment {
  id?: string;
  filename: string;
  content_type?: string;
  size?: number;
  public_url?: string;
}

const TEXT_PREVIEW_TYPES = new Set([
  'text/plain',
  'text/html',
  'text/css',
  'text/csv',
  'text/markdown',
  'text/xml',
  'application/json',
  'application/xml',
  'application/javascript',
  'application/x-javascript',
  'text/javascript',
]);

export const getAttachmentPreviewKind = (
  contentType?: string,
  filename?: string
): AttachmentPreviewKind => {
  const type = (contentType || '').toLowerCase().split(';')[0].trim();
  const ext = (filename || '').split('.').pop()?.toLowerCase() || '';

  if (type.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'].includes(ext)) {
    return 'image';
  }
  if (type === 'application/pdf' || ext === 'pdf') {
    return 'pdf';
  }
  if (type.startsWith('video/') || ['mp4', 'webm', 'ogg', 'mov'].includes(ext)) {
    return 'video';
  }
  if (type.startsWith('audio/') || ['mp3', 'wav', 'ogg', 'm4a', 'aac'].includes(ext)) {
    return 'audio';
  }
  if (
    TEXT_PREVIEW_TYPES.has(type) ||
    ['txt', 'md', 'json', 'xml', 'csv', 'log', 'js', 'ts', 'tsx', 'jsx', 'css', 'html', 'htm'].includes(ext)
  ) {
    return 'text';
  }

  return 'unsupported';
};

export const canPreviewAttachment = (contentType?: string, filename?: string): boolean =>
  getAttachmentPreviewKind(contentType, filename) !== 'unsupported';

/** Max bytes to read for inline text preview */
export const TEXT_PREVIEW_MAX_BYTES = 512 * 1024;
